import * as React from "react";
import PropTypes from "prop-types";

import "./styles.css";
import BigCheckbox from "../big-checkbox";
import ExperienceSelector from "../experience-selector";
import { connectToProps, _ } from "../../model/utils";

const ChooseExperience = ({ hasExperience, setHasExperience }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div styleName="experience-container">
          <BigCheckbox
            checked={hasExperience}
            setChecked={setHasExperience}
            label={_.addExperience}
          />
          {hasExperience && (
            <>
              <p styleName="experience-intro">{_.experienceIntro}</p>
              <ExperienceSelector fieldName="experience" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ChooseExperience.propTypes = {
  hasExperience: PropTypes.bool.isRequired,
  setHasExperience: PropTypes.func.isRequired
};

export default connectToProps(["hasExperience"])(ChooseExperience);
